import React from 'react';
import { SlideDown } from 'react-slidedown';

import RadioButton from 'components/RadioButton';

import { Container, Title, Subtitle, RadioButtonContainer, Row, Body } from './styles';

interface Props {
  title: string;
  subtitle?: string;
  optionValue: string;
  value: string;
  children?: JSX.Element;
  errorMessage?: string;
  handleChangeValue: (value: string) => void;
}

const RadioCard = ({ title, subtitle, optionValue, value, errorMessage, handleChangeValue, children }: Props) => (
  <>
    <Container onClick={() => handleChangeValue(value)} isError={!!errorMessage}>
      <Row isError={!!errorMessage}>
        <div>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </div>
        <RadioButtonContainer>
          <RadioButton value={value} handleChangeValue={() => {}} optionValue={optionValue} />
        </RadioButtonContainer>
      </Row>
      {children && (
        <SlideDown closed={optionValue !== value}>
          <Body>{children}</Body>
        </SlideDown>
      )}
    </Container>
  </>
);

export default RadioCard;
